import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Vuelidate from "vuelidate";
import vue3GoogleLogin from "vue3-google-login";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { isNativePlatform } from "./utils/platform";
import "@/assets/globalcss/style.css";
import "./assets/globalcss/style.css";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueClosable from "vue-closable";

import PosthogPlugin from '../plugins/posthog'


Vue.use(VueClosable)
Vue.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_CLIENT_ID,
});
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(PosthogPlugin)


Vue.config.productionTip = false;

// Initialize Google Auth for native platforms
if (isNativePlatform()) {
  GoogleAuth.initialize({
    clientId: process.env.VUE_APP_CLIENT_ID,
    scopes: ['profile', 'email'],
    grantOfflineAccess: true,
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
